export default function nameToElement(name, values) {
  const path = name.split(".");
  let element = values;
  path.forEach((item) => {
    element = element[item];
  });
  if (!element.modules) element.modules = [];
  return element;
}
